module.exports = __webpack_public_path__ + "static/media/decision-making-big-data.c4a2455c.jpg";